import gql from 'graphql-tag';

export const MARCAR_AVISO_LEIDO = gql`
  mutation MarcarAvisoLeido($avisoId: ID!) {
    avisos {
      marcarLeido(avisoId: $avisoId)
    }
  }
`;

export const MARCAR_TODOS_AVISOS_LEIDOS = gql`
  mutation MarcarTodosAvisosLeidos {
    avisos {
      marcarTodosLeidos
    }
  }
`;
